export default "__VITE_ASSET__YMTkM_fF__"